import { apiEndpoints } from '@/apiEndpoints';
import { HotelResponse } from '@/types/benefits/hotel/HotelResponse';
import { SupportedLocale } from '@/types/supported-locale.type';
import axios from 'axios';

export const createHotel = async (data: FormData) =>
  axios.post(apiEndpoints.hotels.base, data);

export const updateHotel = async (
  benefitId: string,
  data: FormData,
  language?: SupportedLocale,
) =>
  axios.put(apiEndpoints.hotels.detail(benefitId), data, {
    params: { language },
  });

export type CitiesWithHotels = Array<{ city: string }>;

export const getHotelCities = async (country?: string) => {
  const result = await axios.get<CitiesWithHotels>(apiEndpoints.hotels.cities, {
    params: { country },
  });
  return result.data;
};

export const getChains = async () => {
  const result = await axios.get<Array<{ chain: string }>>(
    apiEndpoints.hotels.chains,
  );
  return result.data;
};

export const getHotel = async (benefitId: string) => {
  const result = await axios.get<HotelResponse>(
    apiEndpoints.hotels.detail(benefitId),
  );
  return result.data;
};

export const duplicateHotel = async (benefitId: string, fields: string[]) => {
  const result = await axios.post(apiEndpoints.hotels.duplicate(benefitId), {
    fields,
  });
  return result.data;
};
